import Vue from 'vue';


// TODO: need phoneMask filter get +xx xxx xxx xx44 format in output

Vue.filter('phoneMask', (value) => {
  if (!value) return '';

  return value;
});

Vue.filter('capitalize', (value) => {
  if (!value) return '';

  const valueStr = value.toString();

  return valueStr.charAt(0).toUpperCase() + valueStr.slice(1);
});

Vue.filter('toPrice', value => `$ ${value.toFixed(2)}`);



// WEBPACK FOOTER //
// ./src/lib/filters/index.js